/*
 * @file: user.js
 * @description: Reducers and actions for store/manipulate user's  data
 * @date: 28.11.2019
 * @author: Mohit
 */

/******** Reducers ********/

const initialState = {
  isDirty: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "ISDIRTY_SUCCESS":
      return { ...state, isDirty: action.data };
    case "LOG_OUT":
      return initialState;
    default:
      return state;
  }
}
